<template>
  <v-snackbar v-model="visible" v-bind="options">
    {{ text }}
    <template v-slot:action="{ attrs }">
      <v-btn v-bind="attrs" text @click="visible = false">
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    visible: true,
  }),

  watch: {
    visible(value) {
      if (!value) {
        setTimeout(() => {
          this.$destroy()
        }, 2000)
      }
    },
  },
}
</script>
